import React from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface StatWithTooltipProps {
  value: string | number;
  label?: string;
  tooltip: string;
  className?: string;
  valueClassName?: string;
  labelClassName?: string;
  icon?: React.ReactNode;
}

export function StatWithTooltip({
  value,
  label,
  tooltip,
  className = "",
  valueClassName = "text-2xl font-bold",
  labelClassName = "text-sm text-muted-foreground",
  icon,
}: StatWithTooltipProps) {
  return (
    <TooltipProvider>
      <Tooltip delayDuration={300}>
        <TooltipTrigger asChild>
          <div className={`flex flex-col group cursor-help ${className}`}>
            <div className="flex items-center gap-2">
              {icon && <div className="opacity-70 group-hover:opacity-100 transform transition-all duration-300 group-hover:scale-110 group-hover:rotate-3">{icon}</div>}
              <div className={`${valueClassName} transition-all duration-300 group-hover:translate-x-1 group-hover:scale-105`}>{value}</div>
            </div>
            {label && <div className={`${labelClassName} transition-all duration-300 group-hover:opacity-90 group-hover:translate-y-0.5`}>{label}</div>}
          </div>
        </TooltipTrigger>
        <TooltipContent side="top" align="center" className="max-w-xs">
          <p className="text-xs leading-relaxed">{tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}